import { SubscriptionType } from '@/utils/fetch/fetchProductSubscriptionByRegion';
import type { FormValues } from '../../FormConfig/formData';

/*
 * TYPES
 */

export interface Membership {
  durationMonths: FormValues['durationMonths'];
  rates: {
    discount?: number;
    normal?: number;
    specialOffer?: number;
  };
}

/*
 * HELPERS
 */

const getDiscountPrice = (
  flexibleSubscriptionRate?: number,
  loyalSubscriptionRate?: number
) => {
  if (!flexibleSubscriptionRate || !loyalSubscriptionRate) return undefined;

  return Math.round(
    ((flexibleSubscriptionRate - loyalSubscriptionRate) /
      flexibleSubscriptionRate) *
      100
  );
};

/*
 * HOOKS
 */

export const useMemberships = (
  subscriptions: SubscriptionType[]
): Membership[] => {
  const sixMonthsSubsriptions = subscriptions.filter(
    item =>
      item.customerType === 'normal' &&
      !item.isFlexible &&
      item.minDurationMonths === 6
  );
  const twelveMonthSubscriptions = subscriptions.filter(
    item =>
      item.customerType === 'normal' &&
      !item.isFlexible &&
      item.minDurationMonths === 12
  );
  const flexibleSubscription = subscriptions.find(
    item =>
      item.customerType === 'normal' &&
      item.isFlexible &&
      item.minDurationMonths === 1
  );

  const sixMonthsSpecialSubscription = sixMonthsSubsriptions.find(
    item => item.isSpecialOffer
  );
  const sixMonthsNonSpecialSubscription = sixMonthsSubsriptions.find(
    item => !item.isSpecialOffer
  );
  const twelveMonthsSpecialSubscription = twelveMonthSubscriptions.find(
    item => item.isSpecialOffer
  );
  const twelveMonthsNonSpecialSubscription = twelveMonthSubscriptions.find(
    item => !item.isSpecialOffer
  );

  return [
    {
      durationMonths: '12',
      rates: {
        normal: twelveMonthsNonSpecialSubscription?.rate,
        specialOffer: twelveMonthsSpecialSubscription?.rate,
        discount:
          twelveMonthsSpecialSubscription || twelveMonthsNonSpecialSubscription
            ? getDiscountPrice(
                flexibleSubscription?.rate,
                twelveMonthsSpecialSubscription?.rate ||
                  twelveMonthsNonSpecialSubscription?.rate
              )
            : undefined,
      },
    },
    {
      durationMonths: '6',
      rates: {
        normal: sixMonthsNonSpecialSubscription?.rate,
        specialOffer: sixMonthsSpecialSubscription?.rate,
        discount:
          sixMonthsSpecialSubscription || sixMonthsNonSpecialSubscription
            ? getDiscountPrice(
                flexibleSubscription?.rate,
                sixMonthsSpecialSubscription?.rate ||
                  sixMonthsNonSpecialSubscription?.rate
              )
            : undefined,
      },
    },
    {
      durationMonths: '1',
      rates: {
        normal: flexibleSubscription?.rate,
      },
    },
  ];
};
